<template>
	<div>
		<v-dialog
			v-model="dialog"
			:scrollable="request !== null"
		>
			<div v-if="loading" style="width: 100%; margin: 100px 0;text-align: center;">
				<v-icon color="white" style="font-size: 90px;">fa-spin fas fa-spinner</v-icon>
			</div>

			<transaction-info v-if="request" :request="request" :transaction="transaction" @close="dialog = false" @view="viewClick"></transaction-info>
		</v-dialog>
	</div>
</template>

<script>
import api from "../api";
import transactionInfo from "./transactions/transaction-info.vue";

export default {
	props: {
		trackingNumber: String,
	},
	components: {
		transactionInfo,
	},
	data() {
		return {
			request: null,
			transaction: null,
			dialog: false,
			loading: false,
		};
	},
	created() {
		this.refresh();
	},
	watch: {
		trackingNumber() {
			this.$nextTick(this.refresh);
		},
	},
	methods: {
		refresh() {
			this.request = null;
			this.transaction = null;
			this.dialog = false;

			if (this.trackingNumber) {
				this.dialog = true;
				this.loading = true;
				Promise.all([api.transactionRequest(this.trackingNumber), api.transaction(this.trackingNumber)]).then((r) => {
					this.request = r[0].data;
					this.transaction = r[1].data;
					this.loading = false;
				});
			}
		},
		viewClick(trackingNumber) {
			this.$emit("view", trackingNumber);
		},
	},
};
</script>
